/*
* Johnny Concert
* Kristian Szabo
*/

class tryOnTINT{
    
    constructor(){
        this.widget = document.querySelector("tint-vto")
        this.widget.addEventListener("addToCart", this.addToCart);
        this.widget.addEventListener("removeFromCart", this.addToCart);
    }
    openTINT = async () => {      
        this.pidInput = document.querySelector('form[action$="/cart/add"] input[name="id"]');
        this.valueSelector = document.querySelector("[data-tint-pid='"+this.pidInput.value+"']"); 
        await this.widget.open()

        const variant = {
            name: this.valueSelector.value,
            pid: this.valueSelector.getAttribute('data-tint-pid'),
            tid: this.valueSelector.getAttribute('data-tint-tid'),
            color: this.hexToRgb(this.valueSelector.getAttribute('data-tint-color')),
            region: this.valueSelector.getAttribute('data-tint-region'),
            finish: this.valueSelector.getAttribute('data-tint-finish'),
            coverage: this.valueSelector.getAttribute('data-tint-coverage'),
            cover: this.valueSelector.getAttribute('data-tint-cover')
        }
        // console.log(variant)
        // this.widget.applyProductBySku(this.valueSelector.getAttribute('data-tint-tid'))

        this.widget.applyProduct({
            id: variant.tid,
            name: variant.name,
            // type: "EYEBROWS",
            // brand: "Guccis",
            cover: variant.cover,
            skus: [
                {
                    id: variant.tid,
                    // name: "Gucci Stylo À Sourcils Waterproof Eyebrow Pencil 06 Noir",
                    vto: {
                        id: variant.tid,
                        region: variant.region,
                        color: variant.color,
                        finish: variant.finish,
                        coverage: variant.coverage,
                    },
                },
            ],
        })
      }
    closeTINT(){

    }
    addToCart = async ({detail}) => {
        // console.log(`Added products: ${JSON.stringify(detail)}`);
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                     id: this.valueSelector.getAttribute('data-tint-pid'),
                     quantity: 1
                    }
                  ]
            })
            })
            .then(response => response.json())
            .then(data => { console.log(data) });
    }
    removeFromCart = ({detail}) => {
        // console.log(`Removed products: ${JSON.stringify(detail)}`)
    }

    hexToRgb(hex) {
        hex = hex.replace('#', '');
        const r = (parseInt(hex.substring(0, 2), 16)/255).toFixed(3);
        const g = (parseInt(hex.substring(2, 4), 16)/255).toFixed(3);
        const b = (parseInt(hex.substring(4, 6), 16)/255).toFixed(3);
        return `${r} ${g} ${b}`;
    }
}

// document.querySelector('form[action$="/cart/add"] input[name="id"]').value
